import { useEffect } from 'react';
import ReactDatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import { vi } from 'date-fns/locale/vi';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.css';

// Register Vietnamese locale
registerLocale('vi', vi);

interface DatePickerProps {
  selected: Date | null;
  onChange: (date: Date | null) => void;
  disabled?: boolean;
  className?: string;
  placeholderText?: string;
  isDark?: boolean;
  showMonthYearPicker?: boolean;
}

export default function DatePicker({
  selected,
  onChange,
  disabled = false,
  className = '',
  placeholderText = 'Chọn ngày',
  isDark = false,
  showMonthYearPicker = false,
}: DatePickerProps) {
  // Apply dark theme to portal
  useEffect(() => {
    const portal = document.getElementById('date-picker-portal');
    if (portal) {
      if (isDark) {
        portal.classList.add('dark');
      } else {
        portal.classList.remove('dark');
      }
    }
  }, [isDark]);

  return (
    <div className={isDark ? 'dark' : ''}>
      <ReactDatePicker
        selected={selected}
        onChange={onChange}
        disabled={disabled}
        dateFormat={showMonthYearPicker ? "MM/yyyy" : "dd/MM/yyyy"}
        locale="vi"
        calendarStartDay={1} // Start week on Monday (Thứ 2)
        className={className}
        placeholderText={placeholderText}
        showPopperArrow={false}
        popperPlacement="bottom-start"
        popperClassName="date-picker-popper"
        withPortal={true}
        portalId="date-picker-portal"
        popperProps={{
          strategy: 'fixed',
        }}
        showMonthYearPicker={showMonthYearPicker}
      />
    </div>
  );
}
